// extracted by mini-css-extract-plugin
export default {"subscriptionAction":"UserSubscriptionDetails_subscriptionAction__R7JE3","button":"UserSubscriptionDetails_button__PVwAc","cancelButton":"UserSubscriptionDetails_cancelButton__EGZLV"};